import { Col, Image, Row, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { FullWidthSpace, SecondaryButton } from 'components';
import { ServiceSection, MakeBookingButton } from './components';
import TeladocBanner from '../../assets/images/teladoc/teladoc-banner.svg';
import TeladocIcon from '../../assets/images/teladoc/teladoc-icon.svg';
import MedicalAdviceIcon from '../../assets/images/teladoc/medical-advice-icon.svg';
import MentalHealthIcon from '../../assets/images/teladoc/mental-health-icon.svg';

const { Title, Text, Link } = Typography;

const Banner = styled(Row)<{ isAdminLoggedIn?: boolean }>`
  background-image: url(${TeladocBanner});
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 420px;
  position: absolute;
  top: ${(props) => (props.isAdminLoggedIn ? '8rem' : '4rem')};
  left: 0;
`;

const BannerContent = styled(Row)`
  margin-top: 3.5rem;
`;

const TeledocTitle = styled(Title)`
  color: white !important;
`;

const ServiceList = styled(Space)`
  margin-top: 4rem;
`;

interface TeladocPageProps {
  isAdminLoggedIn?: boolean;
}

export const TeladocPage = ({ isAdminLoggedIn }: TeladocPageProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <Banner isAdminLoggedIn={isAdminLoggedIn} />
      <BannerContent>
        <Col xs={24} md={12}>
          <FullWidthSpace direction="vertical" size="middle">
            <Image src={TeladocIcon} preview={false} />
            <TeledocTitle level={2}>{t('teladoc.screenHeading')}</TeledocTitle>
            <Text style={{ color: 'white' }}>{t('teladoc.description')}</Text>
            <Space>
              <MakeBookingButton />
              <Link href={t('teladoc.teleconsultationLink')} target="_blank">
                <SecondaryButton>{t('home.reminderMsgButton')}</SecondaryButton>
              </Link>
            </Space>
          </FullWidthSpace>
        </Col>
      </BannerContent>
      <ServiceList direction="vertical">
        <Title level={3}>{t('teladoc.servicesHeading')}</Title>
        <Row gutter={[16, 16]}>
          <ServiceSection
            icon={MedicalAdviceIcon}
            title={t('teladoc.serviceAdvice')}
            description={t('teladoc.serviceAdviceDescription')}
          />
          <ServiceSection
            icon={MentalHealthIcon}
            title={t('teladoc.serviceMentalHealth')}
            description={t('teladoc.serviceMentalHealthDescription')}
          />
        </Row>
      </ServiceList>
    </>
  );
};
